import { render } from "./DiscountCopy.vue?vue&type=template&id=c7a9654a&scoped=true"
import script from "./DiscountCopy.vue?vue&type=script&lang=js"
export * from "./DiscountCopy.vue?vue&type=script&lang=js"

import "./DiscountCopy.vue?vue&type=style&index=0&id=c7a9654a&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a9654a"]])

export default __exports__